import React from "react";
import { Icon } from "@chakra-ui/react";

// A plain paperclip. The 📎 emoji can't be used: Windows 11 draws it as
// Clippy (a paperclip with eyes).
export default function PaperclipIcon(props) {
  return (
    <Icon viewBox="0 0 24 24" boxSize="1.1em" color="gray.500" aria-hidden="true" data-testid="paperclip-icon" {...props}>
      <path
        transform="rotate(45 12 12) translate(2.5 0)"
        d="M12 5.5V16a2.5 2.5 0 0 1-5 0V6a4 4 0 0 1 8 0v11.5a5.5 5.5 0 0 1-11 0V8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
